import { render } from "./KaTeXComponent.vue?vue&type=template&id=0958fb42&scoped=true"
import script from "./KaTeXComponent.vue?vue&type=script&lang=js"
export * from "./KaTeXComponent.vue?vue&type=script&lang=js"

import "./KaTeXComponent.vue?vue&type=style&index=0&id=0958fb42&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0958fb42"]])

export default __exports__